import i18n from "@/i18n";

/**
 * Format an ISO date string for display in the given timezone.
 * Single formatter: we only pass the timezone (e.g. "UTC" now, later store.state.userTimeZone).
 * Uses Intl so the same code path handles UTC and any other IANA timezone.
 */
export function formatDateForDisplay(
    value: string,
    format: string = "DD-MM-YYYY HH:mm",
    timeZone: string = "UTC"
): string {
    if (typeof value !== "string") return String(value ?? "");
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";

    const opts: Intl.DateTimeFormatOptions = {
        timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
    };
    const parts = new Intl.DateTimeFormat("en-CA", opts).formatToParts(date);
    const get = (type: Intl.DateTimeFormatPartTypes) =>
        parts.find((p: Intl.DateTimeFormatPart) => p.type === type)?.value ?? "";

    // Replace in order so MMM is before MM
    return format
        .replace("YYYY", get("year"))
        .replace("MMM", i18n.tc("general.monthShort." + (parseInt(get("month"), 10) - 1)))
        .replace("MM", get("month"))
        .replace("DD", get("day"))
        .replace("dd", get("day"))
        .replace("HH", get("hour"))
        .replace("mm", get("minute"))
        .replace("ss", get("second"));
}
